import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavProfileIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M12 5.5C12 4.39543 11.1046 3.5 10 3.5C8.89543 3.5 8 4.39543 8 5.5C8 6.60457 8.89543 7.5 10 7.5C11.1046 7.5 12 6.60457 12 5.5ZM13.5 5.5C13.5 7.433 11.933 9 10 9C8.067 9 6.5 7.433 6.5 5.5C6.5 3.567 8.067 2 10 2C11.933 2 13.5 3.567 13.5 5.5Z"
          fill="inherit"
        />
        <path
          d="M16.0908 18C17.1452 18 18 17.1452 18 16.0908C18 13.2793 15.7207 11 12.9092 11H7.09082C4.27926 11 2.00005 13.2793 2 16.0908C2 17.0793 2.75121 17.8925 3.71387 17.9902L3.90918 18H16.0908ZM3.90918 16.5C3.68325 16.5 3.5 16.3168 3.5 16.0908C3.50005 14.1077 5.10769 12.5 7.09082 12.5H12.9092C14.8923 12.5 16.5 14.1077 16.5 16.0908C16.5 16.3168 16.3168 16.5 16.0908 16.5H3.90918Z"
          fill="inherit"
        />
      </g>
    </SvgWrapper>
  );
}
